/**
 * Returns true if the app is running in a local environment.
 * Covers: localhost, *.localhost subdomains, IPv6 loopback, and IPv4 loopback range.
 */
const isLocalhost = () => {
  const { hostname } = window.location;
  return (
    hostname === "localhost" ||
    hostname.endsWith(".localhost") ||
    hostname === "[::1]" ||
    Boolean(hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/))
  );
};

export default isLocalhost;
